"use client";

import React from "react";
import Image from "next/image";
import SiteNav from "@/components/modules/SiteNav";
import Countdown from "./Countdown";
import { KV } from "./data";

const HomeHero: React.FC = () => {
  return (
    <section className="relative bg-brand-blue text-white overflow-hidden min-h-[100svh] flex flex-col">
      {/* Diagonal guide lines */}
      <svg
        aria-hidden
        className="absolute inset-0 w-full h-full pointer-events-none"
        viewBox="0 0 100 100"
        preserveAspectRatio="none"
      >
        <g stroke="rgba(255,255,255,0.22)" strokeWidth="1" vectorEffect="non-scaling-stroke">
          <line x1="0" y1="62" x2="100" y2="14" vectorEffect="non-scaling-stroke" />
          <line x1="0" y1="98" x2="100" y2="50" vectorEffect="non-scaling-stroke" />
          <line x1="22" y1="0" x2="58" y2="100" vectorEffect="non-scaling-stroke" />
          <line x1="52" y1="0" x2="88" y2="100" vectorEffect="non-scaling-stroke" />
          <line x1="0" y1="26" x2="100" y2="-22" vectorEffect="non-scaling-stroke" />
        </g>
      </svg>

      {/* KV sun + wave line-art */}
      <div className="absolute top-[22%] md:top-[16%] -right-[6%] w-[80vw] md:w-[50vw] opacity-90 pointer-events-none">
        <Image
          src={KV.sunWaves}
          alt=""
          width={2400}
          height={1080}
          priority
          sizes="(max-width: 768px) 80vw, 50vw"
          className="w-full h-auto"
        />
      </div>

      <SiteNav variant="hero" />

      {/* Race-day countdown */}
      <div className="relative z-10 flex-1 flex items-center justify-center px-4 md:px-8 py-16 md:py-10 pb-36 sm:pb-28">
        <Countdown />
      </div>

      {/* Horizon line + Ferris wheel mark (left) */}
      <div className="absolute z-20 left-4 md:left-8 bottom-6 md:bottom-8 w-40 md:w-60 [@media(max-height:500px)]:hidden">
        {/* rueda.png es un PNG animado (APNG): el Image CDN de Netlify lo convierte a
            WebP estático y se pierde el giro, así que se sirve tal cual. */}
        <Image src={KV.rueda} alt="" width={1200} height={610} unoptimized className="w-full h-auto" />
        <div className="h-[2px] bg-white -mt-[1px]" />
      </div>

    </section>
  );
};

export default HomeHero;
